<div class="user-profile-details">
<p-fieldset legend="eQMS Scope(s) Assignment" [toggleable]="true">
    <app-tree class="eQMS-scope" id="userProfileeQMSScope" [treeData]="treeData"></app-tree>
</p-fieldset>
<p-fieldset legend="Organization" [toggleable]="true">
    <div class="grid">
        <div class="col-3">
            <app-label labelText="Manager"></app-label>
            <app-read-only [readonlyText]="userProfile?.managerUserName || notApplicableText"></app-read-only>
        </div>
        <div class="col-3">
            <app-label labelText="Direct Report(s)"></app-label>
            <app-read-only *ngFor="let directReport of userProfile?.directReporties" readonlyText="{{directReport}}"></app-read-only>
        </div>
        <div class="col-3">
            <app-label labelText="Cost Center"></app-label>
            <app-read-only readonlyText="{{userProfile?.costCenter}}"></app-read-only>
        </div>
    </div>
</p-fieldset>
<p-fieldset legend="Security/Permissions" [toggleable]="true">
    <div class="grid">
        <div class="col-3">
            <app-label labelText="Security/Permissions"></app-label>
            <app-read-only *ngFor="let permission of userProfile?.securityPermissions; trackBy: trackByPermission" [readonlyText]="permission"></app-read-only>
        </div>
    </div>
</p-fieldset>
<p-fieldset legend="Skills" [toggleable]="true">
    <div class="grid">
        <div class="col-3">
            <app-label labelText="Earned Skills"></app-label>
            <ng-container *ngTemplateOutlet="skillsTemplate; context: { $implicit: userAssignedSkills?.earned, emptyTemplate: noSkills }"></ng-container>
            <ng-template #noSkills>
                <app-read-only readonlyText="N/A"></app-read-only>
            </ng-template>
        </div>
        <div class="col-3">
            <app-label labelText="Pending Acknowledgement"></app-label>
            <ng-container *ngTemplateOutlet="skillsTemplate; context: { $implicit: userAssignedSkills?.pendingAcknowledgement, emptyTemplate: noSkills }"></ng-container>
        </div>
        <div class="col-3">
            <app-label labelText="Pending Verification"></app-label>
            <ng-container *ngTemplateOutlet="skillsTemplate; context: { $implicit: userAssignedSkills?.pendingVerification, emptyTemplate: noSkills }"></ng-container>
        </div>
        <div class="col-3">
            <app-label labelText="Removed Skills"></app-label>
            <ng-container *ngTemplateOutlet="skillsTemplate; context: { $implicit: userAssignedSkills?.removed, emptyTemplate: noSkills }"></ng-container>
        </div>
    </div>
</p-fieldset>
<ng-template #skillsTemplate let-skills let-empty="emptyTemplate">
    <div *ngIf="skills?.length; else empty">
        <div *ngFor="let skill of skills; trackBy: trackBySkillCode" class="mt-1">
            <em class="pi pi-external-link blue-color cursor-pointer" (click)="viewSkillDetails(skill.skillCode, skill.skillName)"></em>
            <a class="ml-3 underline blue-color cursor-pointer overflow-ellipse" (click)="viewSkillDetails(skill.skillCode, skill.skillName)" [title]="skill.skillName">
                {{ skill.skillCode }} {{(skill.skillName.length > 15) ? (skill.skillName | slice:0:15) + '...' : skill.skillName }}
            </a>
        </div>
    </div>
</ng-template>
<p-fieldset legend="Dates" [toggleable]="true">
    <div class="grid">
        <div class="col-3">
            <app-label labelText="Hire Date"></app-label>
            <app-read-only [readonlyText]="(userProfile?.hireDate | date: 'dd-MMM-yyyy') || notApplicableText"></app-read-only>
        </div>
        <div class="col-3">
            <app-label labelText="Termination Date"></app-label>
            <app-read-only [readonlyText]="(userProfile?.terminationDate | date: 'dd-MMM-yyyy') || notApplicableText"></app-read-only>
        </div>
    </div>
    <div class="grid">
        <div class="col-3">
            <app-label labelText="Last Training Plan Review Date"></app-label>
            <app-read-only [readonlyText]="(userProfile?.lastTrainingPlanReviewDate | date: 'dd-MMM-yyyy') || notApplicableText"></app-read-only>
        </div>
        <div class="col-3">
            <app-label labelText="Next Training Plan Review Date"></app-label>
            <app-read-only [readonlyText]="(userProfile?.nextTrainingPlanReviewDate | date: 'dd-MMM-yyyy') || notApplicableText"></app-read-only>
        </div>
    </div>
</p-fieldset>
<p-fieldset legend="Attachments" [toggleable]="true">
    <div *ngFor="let attachment of userProfile?.attachments; trackBy: trackByAttachmentId" class="mt-1">
        <em class="blue-color cursor-pointer" (click)="downloadAttachment(attachment.attachmentFileId, attachment.attachmentName)">
            <app-file-icon [fileType]="attachment.attachmentType"></app-file-icon>
        </em>
        <span class="ml-3">{{ attachment.attachmentName }}</span>
        <em class="ml-2 fa fa-trash blue-color cursor-pointer" (click)="deleteAttachment(attachment.attachmentId!)"></em>
    </div>
</p-fieldset>
</div>

<app-confirmation [showConfirmationModal]="showConfirmationModal" [confirmationMessage]="confirmationMessage" (closeConfirmation)="closedConfirmation($event)" (confirm)="confirmDelete($event)"></app-confirmation>
